import React, { useEffect, useState } from 'react';
import IncrementDecrement from '../../../FlowConfigurationInputs/IncrementDecrement/IncrementDecrement';
/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Scroll ({ action }) {
    const [pixel, setPixel] = useState();
    useEffect(() => {
        if (!action.fields.incrementState) {
            action.fields.incrementState = { value: 1 };
            setPixel(action.fields.incrementState.value * 114);
        }
    }, [action]);

    const handleIncrement = () => {
        action.fields.incrementState.value++;
        setPixel(action.fields.incrementState.value * 114);
    };

    const handleDecrement = () => {
        if (action.fields.incrementState.value - 1 > 0) {
            action.fields.incrementState.value--;
            pixel - 114 > 0 ? setPixel(pixel - 114) : setPixel(pixel);
        }
    };

    return <IncrementDecrement action={action} handleIncrement={handleIncrement} handleDecrement={handleDecrement} />;
}

export default Scroll;